/**
 * 详情
 */
import React, { useEffect, useState } from 'react';
import styles from './collaborativeDetails.module.scss';
import { ApiCore } from '../../api';
import { createFromIconfontCN } from '@ant-design/icons';

const api = new ApiCore();

//设置阿里图库地址
const IconFont = createFromIconfontCN({
    scriptUrl: '//at.alicdn.com/t/font_2323742_xvjwsudf76n.js',
});

function CollaborativeDetails(props: any) {
    let url = sessionStorage.getItem('fileUrl')
    let fileName = sessionStorage.getItem('fileName')
    let imgList = url ? url.split(',') : []

    useEffect(() => {
        //设置网页title
        document.title = fileName || '详情';
    }, [])

    return (
        <div className={styles.collaborativeDetails}>
            {
                imgList.length > 0 && imgList.map((item: any, index: any) => (
                    <div key={index} className={styles.img_content} style={{ marginTop: index == 0 ? 0 : '8px' }}>
                        <img src={item} alt='' width={'100%'} />
                    </div>
                ))
            }
        </div>
    )
}

export default CollaborativeDetails;